import { render, staticRenderFns } from "./BizInfo.vue?vue&type=template&id=114acaa0&scoped=true&lang=pug&"
import script from "./BizInfo.vue?vue&type=script&lang=ts&"
export * from "./BizInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114acaa0",
  null
  
)

export default component.exports